/**
 * deployment-sub-menu-item.js
 */

import React from 'react';
import { Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useTranslation } from 'react-i18next';
import { Types } from 'utils/constants';
import DrawerMenuItem from 'components/menu-drawer/menu/drawer-menu-item';
import Icon from 'components/icon';
import IconPatrolDetection from 'components/icon-patrol-detection';


const useStyles = makeStyles(theme => ({
  label: {
    lineHeight: 1.3,
  },
  complete: {
    color: theme.palette.success.dark
  }
}));


export default function DeploymentSubMenuItem(props) {
  const {
    record,
    type,
    to,
    isActive,
    iconName,
  } = props;
  const classes = useStyles();
  const { t: gt } = useTranslation('general');


  const getTitle = () => {
    if (type === Types.DeploymentSection.GENERAL) {
      return 'General';
    } else if (type === Types.DeploymentSection.DETECTION) {
      return 'Detection';
    } else if (type === Types.DeploymentSection.PATROL) {
      return Boolean(record?.id)
        ? `${Types.Patrol.getName(gt, record.type)}`
        : `New Patrol Type`
    } else if (type === Types.DeploymentSection.SUMMARY) {
      return 'Summary';
    }
  }


  const label = (
    <div 
      className='flex-hc'
      style={{ justifyContent: 'space-between' }}
    >
      <Typography variant="body2" className={classes.label}>
        {getTitle()}
      </Typography>

      <Icon type={iconName} className={classes[iconName]} />
    </div>
  );


  const icon = type === Types.DeploymentSection.DETECTION || type === Types.DeploymentSection.PATROL
    ? <IconPatrolDetection 
        workMode={type === Types.DeploymentSection.DETECTION 
          ? Types.WorkMode.DETECTION 
          : Types.WorkMode.PATROL} 
        patrolType={record?.type || Types.Patrol.OTHER} 
      />
    : type === Types.DeploymentSection.GENERAL
      ? <Icon type='summary' />
      : <Icon type='comment' />


  return (
    <>
      <DrawerMenuItem
        id={`patrol-type-${record?.id}`}
        icon={icon}
        label={label}
        to={to}
        isActive={isActive}
      />
    </>
  );
}